import React, { useEffect, useContext, useState } from 'react';
import { StateContext } from '../../StateContainer';
import axios from 'axios';
import { IoCheckmarkDoneCircleSharp as IconaFatto } from 'react-icons/io5';
import { Link } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';
import { MarkerType } from '@xyflow/react';
import { extractOutputIntents } from '../../../utils/outputIntent';

const ModalDeleteVersion = ({
  versioniAgenteConversazionale,
  setVersioniAgenteConversazionale,
  setDettagliNodi,
  nodes,
  dettagliNodi,
  currentConversationalVersion,
  setCurrentConversationalVersion,
  setNodes,
  setEdges,
  viewport,
  id,
}) => {
  const { error, setError, token } = useContext(StateContext);

  const [newVersionName, setNewVersionName] = useState('');
  const [useExistingVersion, setUseExistingVersion] = useState(true);
  const [showWarning, setShowWarning] = useState(false);

  const [titoloProgetto, setTitoloProgetto] = useState('');
  const [tipoProgetto, setTipoProgetto] = useState('conversational');
  const [loadingProject, setLoadingProject] = useState(false);
  const [selectedVersionToUpload, setSelectedVersionToUpload] = useState(
    currentConversationalVersion,
  );
  const [versionLive, setVersionLive] = useState(false);

  useEffect(() => {
    setSelectedVersionToUpload(currentConversationalVersion);
  }, [currentConversationalVersion]);

  const closeModalCreateButton = document.getElementById(
    'ModalDeleteVersionButton',
  );

  const EliminaVersione = () => {
    setDettagliNodi((prev) => {
      const updatedDetails = { ...prev };
      nodes.forEach((node) => {
        if (updatedDetails[`nodo-${node.id}`]) {
          updatedDetails[`nodo-${node.id}`].position = node.position;
        }
      });
      return updatedDetails;
    });

    axios({
      method: 'post',
      url: `${process.env.REACT_APP_BASE_URL}/version/delete`,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: {
        projectCode: id,
        version: selectedVersionToUpload,
      },
    })
      .then((response) => {
        if (response.status === 401) {
          localStorage.removeItem('token');
          localStorage.removeItem('tokenExpiration');
          window.location.replace('/login');
        } else {
          let error = response.data.response.error;
          if (error) {
            toast.error(error);
            if (closeModalCreateButton) {
              closeModalCreateButton.click();
            }
            return;
          } else {
            toast.success('Versione eliminata correttamente');
          }
          if (closeModalCreateButton) {
            closeModalCreateButton.click();
          }
          setUseExistingVersion(true);
          setNewVersionName('');
          setShowWarning(false);
          setCurrentConversationalVersion(response.data.response.id);
          setSelectedVersionToUpload(response.data.response.id);

          // Modifico lo schema
          let editorValueArray = JSON.parse(
            response.data.response.conversationalJSON,
          );

          if (editorValueArray) {
            const newNodes = Object.keys(editorValueArray)
              .filter(
                (key) => key !== 'fullfillment_variables' && key !== 'viewport',
              )
              .map((key) => {
                const nodeData = editorValueArray[key];
                return {
                  id: nodeData.id ? nodeData.id.toString() : '',
                  type: nodeData.type,
                  data: { label: nodeData.node_label, actions: [] },
                  position: nodeData.position,
                };
              });

            setNodes(newNodes);

            const listFullfillmentVariables =
              editorValueArray.fullfillment_variables || [];

            const fullfillmentVariables = listFullfillmentVariables.filter(
              (fv) =>
                fv.label === '' &&
                fv.nome_variabile === '' &&
                fv.istruzioni_estrazione === '',
            );

            const newDettagliNodi = Object.keys(editorValueArray).reduce(
              (acc, key) => {
                if (key !== 'fullfillment_variables' && key !== 'viewport') {
                  const nodeData = editorValueArray[key];
                  acc[key] = {
                    node_label: nodeData.node_label,
                    id: nodeData.id,
                    type: nodeData.type,

                    position: nodeData.position,
                    intents: nodeData.intents || [],
                    fullfillment:
                      fullfillmentVariables.filter(
                        (fv) => fv.nodeId === nodeData.id,
                      ) || [],
                  };
                }
                return acc;
              },
              {},
            );

            const newEdges = [];
            Object.keys(newDettagliNodi).forEach((key) => {
              const node = newDettagliNodi[key];
              if (node.intents) {
                node.intents.forEach((intent) => {
                  let target = intent.target.toString();
                  let source = node.id.toString();
                  newEdges.push({
                    id: `${node.id}-${intent.target}`,
                    source: node.id.toString(),
                    target: intent.target.toString(),
                    animated: true,
                    type: source === target ? 'selfconnecting' : 'custom_edge',
                    markerEnd: {
                      type: MarkerType.ArrowClosed,
                      width: 20,
                      height: 20,
                    },
                    data: {
                      trigger: intent.trigger,
                      ...extractOutputIntents(intent),
                      forceIntent: intent.forceIntent,
                      type: 'action',
                      id: intent.id,
                      target: intent.target,
                      source: node.id,
                    },
                  });
                });
              }
            });

            setEdges(newEdges);
          }

          // Dettagli nodi
          setDettagliNodi(
            JSON.parse(response.data.response.conversationalJSON),
          );
          setVersioniAgenteConversazionale(
            response.data.response.versionsConversational,
          );
        }
      })
      .catch((err) => setError(err));
  };

  return (
    <div
      className="modal fade overlay"
      id="ModalDeleteVersion"
      tabIndex="-1"
      aria-labelledby="ModalDeleteVersion"
      aria-hidden="true"
      data-bs-backdrop="false"
      style={{ zIndex: '99999999999999999999999999999999999' }}
    >
      <div className="modal-dialog modal-dialog-centered text-center">
        <div className="modal-content">
          <div className="modal-header border-0 py-4 text-center">
            <h5 className="modal-title text-center">Elimina versione</h5>
          </div>
          <div className="modal-body">
            <p>
              Confermi di procedere all'eliminazione della seguente versione:
            </p>
            <hr />
            <h3>
              {(() => {
                const versioneCorrente =
                  versioniAgenteConversazionale &&
                  versioniAgenteConversazionale.find(
                    (v) => v.id === parseInt(currentConversationalVersion),
                  );
                return versioneCorrente ? `${versioneCorrente.name}` : 'h';
              })()}
            </h3>
          </div>
          <div className="modal-footer">
            <div className="d-flex w-100 gap-2">
              <button
                type="button"
                className="btn btn-secondary w-50"
                data-bs-dismiss="modal"
                id="ModalDeleteVersionButton"
              >
                Annulla
              </button>
              <button
                type="button"
                className="btn bg-danger text-white w-50"
                onClick={EliminaVersione}
                id="creaProgettoButton"
              >
                Elimina
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalDeleteVersion;
